import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Checkbox, Divider, } from 'antd'
import { setPakketFilters, clearAttrFilter, clearFilters } from '../../redux/actions/shopActions'
import { hideSideBar } from '../../redux/actions/miscActions'

export class PakketFilters extends Component {


  handleClearFilters=()=>{
    this.props.clearAttrFilter()
    this.props.clearFilters()
    this.props.hideSideBar()
  }

  setProductFilters=(value)=>{
    if(value.length === 0){
      this.props.clearFilters()
      this.props.hideSideBar()
    } else {
      this.props.setPakketFilters(value[0])
      this.props.hideSideBar()
    }
  }


  handleLinkClick=(link)=>{
    this.props.history.push(`/${link}`)
    this.props.hideSideBar()
  }

  render() {
    const { pakketFilters } = this.props.shop
    return (
      <div className="shop-filters">
      <div className="header">
      <h3>Filters</h3>
      {pakketFilters.length > 0 ? <h3 onClick={this.handleClearFilters}>Wis filters</h3> : null}
      </div>
      <Checkbox.Group
        onChange={this.setProductFilters}
        value={pakketFilters}
        className="main-filter"
      >
              <Checkbox value="healthy_greans_small">Healthy greans small</Checkbox>
              <Checkbox value="healthy_greans_medium">Healthy greans medium</Checkbox>
              <Checkbox value="healthy_greans_large">Healthy greans large</Checkbox>
      </Checkbox.Group>
      <Divider />
        <p className="link" onClick={()=>this.handleLinkClick('')}>
        Zelf samenstellen <i className="fas fa-angle-right"></i>
        </p>      
    </div>
    )
  }
}


const mapStateToProps = (state) => ({
  shop: state.shop,
  misc: state.misc
})

export default connect(mapStateToProps, { setPakketFilters, clearAttrFilter, clearFilters, hideSideBar })(withRouter(PakketFilters))
